import axios from 'axios';

const API_BASE_URL = '/api'; // Usar proxy do Vite

// Configurar axios com interceptors
const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
  withCredentials: true, // ✅ Enviar cookies automaticamente
  headers: {
    'Content-Type': 'application/json',
  }
});

// ✅ SEGURANÇA: Tokens agora em cookies httpOnly
// Navegador envia automaticamente, não precisa adicionar manualmente
api.interceptors.request.use(
  (config) => {
    // Cookies são enviados automaticamente pelo navegador
    return config;
  },
  (error) => Promise.reject(error)
);

// Interceptor para tratamento de erros
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('user');
      localStorage.removeItem('sessionStartTime');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

/**
 * Serviço para gerenciamento de opções dinâmicas
 */

// ==================== TIPO PARCERIA ====================

export const getTiposParceria = async () => {
  const response = await api.get('/options/tipo-parceria');
  return response.data;
};

export const createTipoParceria = async (nome) => {
  const response = await api.post('/options/tipo-parceria', { nome });
  return response.data;
};

export const updateTipoParceria = async (id, nome) => {
  const response = await api.put(`/options/tipo-parceria/${id}`, { nome });
  return response.data;
};

export const deleteTipoParceria = async (id) => {
  const response = await api.delete(`/options/tipo-parceria/${id}`);
  return response.data;
};

// ==================== ORIGEM ====================

export const getOrigens = async () => {
  const response = await api.get('/options/origem');
  return response.data;
};

export const createOrigem = async (nome) => {
  const response = await api.post('/options/origem', { nome });
  return response.data;
};

export const updateOrigem = async (id, nome) => {
  const response = await api.put(`/options/origem/${id}`, { nome });
  return response.data;
};

export const deleteOrigem = async (id) => {
  const response = await api.delete(`/options/origem/${id}`);
  return response.data;
};

// ==================== PRAZOS ====================

export const getPrazos = async () => {
  const response = await api.get('/options/prazos');
  return response.data;
};

export const createPrazo = async (dias) => {
  const response = await api.post('/options/prazos', { dias });
  return response.data;
};

export const updatePrazo = async (id, dias) => {
  const response = await api.put(`/options/prazos/${id}`, { dias });
  return response.data;
};

export const deletePrazo = async (id) => {
  const response = await api.delete(`/options/prazos/${id}`);
  return response.data;
};

const OptionsService = {
  getTiposParceria,
  createTipoParceria,
  updateTipoParceria,
  deleteTipoParceria,
  getOrigens,
  createOrigem,
  updateOrigem,
  deleteOrigem,
  getPrazos,
  createPrazo,
  updatePrazo,
  deletePrazo
};

export default OptionsService;
